import React, { Component } from "react";
import "./SingleComment.css";
import { withFirebase } from "../../Firebase";
import { withRouter } from "react-router-dom";
import DefaultProfileImg from '../../../components/assets/icon_user_profile.svg';
import Tooltip from '@material-ui/core/Tooltip';
import editImage from '../../../assets/pencil.svg';
import iconDelete from "../../../assets/delete.svg";
import EdiText from 'react-editext';
import Modal from "react-responsive-modal";
import DeleteCommentContent from "./DeleteComment";

class SingleComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: this.props.comment,
            index: this.props.index,
            currentUserId: this.props.currentUserId,
            editingComment: false,
            deleteCommentOpen: false,
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentUserId !== this.state.currentUserId) {
            this.setState({ currentUserId: nextProps.currentUserId })
        }
    }

    onEdit = () => {
        this.setState({
            editingComment: !this.state.editingComment
        })
    }

    onSaveComment = val => {
        let comment = this.state.comment
        comment.comment = val
        this.setState({ comment })
        this.props.updateIdeaComments(comment, this.state.index)
    }

    openDeleteComment = () => {
        this.setState({
            deleteCommentOpen: true
        })
    }

    closeDeleteComment = () => {
        this.setState({
            deleteCommentOpen: false
        })
    }

    render() {
        const { comment, currentUserId, index } = this.state
        return (
            <div className="mb-3 position-relative">
                <div className="d-flex mt-2">
                    <img alt="icon" className="idea-profile" src={comment.creator.image_url_profile || DefaultProfileImg} />
                    <div className="ml-3">
                        <span className="idea-profile-name">
                            {comment.creator.firstname} {comment.creator.lastname}
                        </span>
                        <h2 className="idea-profile-position">{comment.creator.position}</h2>
                    </div>
                    <div className="comment-actions">
                        <Tooltip title="Editer" aria-label="editer" hidden={comment.creatorId !== currentUserId}>
                            <img src={editImage} alt="edit" className="edit-icon cursor-pointer" onClick={this.onEdit}></img>
                        </Tooltip>
                        <Tooltip title="Supprimer" aria-label="supprimer" hidden={comment.creatorId !== currentUserId}>
                            <img src={iconDelete} className="edit-icon cursor-pointer" onClick={this.openDeleteComment} alt="deleteIdea" />
                        </Tooltip>
                    </div>
                </div>
                <EdiText
                    type='textarea'
                    value={comment.comment}
                    onSave={this.onSaveComment}
                    viewContainerClassName='my-custom-view-wrapper'
                    editing={this.state.editingComment}
                    editButtonClassName="comment-edit"
                    saveButtonContent="OK"
                    cancelButtonContent="X"
                    saveButtonClassName="comment-choice comment-green"
                    cancelButtonClassName="comment-choice comment-red"
                    inputProps={{
                        rows: 3
                    }}
                />
                <Modal
                    open={this.state.deleteCommentOpen}
                    onClose={this.closeDeleteComment}
                    center
                    showCloseIcon={true}
                    styles={styles_delete}
                >
                    <DeleteCommentContent
                        onClose={this.closeDeleteComment}
                        openDelete={this.openDeleteComment}
                        deleteIdeaComment={this.props.deleteIdeaComment}
                        commentIndex={index} />
                </Modal>
            </div>
        );
    }
}

const styles_delete = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "355px",
        maxWidth: "321px",
        top: "10%",
        padding: "0px",
    }
};


const SingleCommentConnected = withRouter(withFirebase(SingleComment));

export { SingleCommentConnected as SingleComment }